var version = {
    "name":      "dativery",
    "buildDateCode": "20260417-144558",
    "buildDate": "Fri Apr 17 2026 14:45:58 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260417-144558",
    "backupUIVersion": "2.2.0-20250522-134816"
}
;
 export default version;